




















































import { Component, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import _ from "@/boot/lodash";
import { mapGetters } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { ILead, ILeadForm } from "@/models/leads";

// Services

@Component({
  computed: {
    ...mapGetters({
      canShowNotesAndSecrets: "data/clients/vaultAssets/canShowNotesAndSecrets"
    })
  },
  components: {
    "lead-form": () => import("@/components/app/admin/leads/leadForm.vue")
  }
})
export default class AddLeadModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Getters

  public canShowNotesAndSecrets!: boolean;

  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    name: HTMLFormElement;
  };

  // Data

  public form: ILeadForm = {
    name: "",
    email: "",
    note: "",
    brand_id: ""
  };
  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    if (!this.canCreateLead) return;

    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      const { id } = await this.createLead();
      await this.createLeadNote(id);

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.lead_successfully_added")
      });

      this.$router.push({ name: "adminLead", params: { leadId: id } });
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public createLead() {
    return this.$store.dispatch(`data/${DataModules.LEADS}/create`, {
      data: _.omit(this.form, ["note"])
    });
  }

  public createLeadNote(leadId: ILead["id"]) {
    if (!this.form.note?.length || !this.canShowNotesAndSecrets)
      return Promise.resolve();

    return this.$store.dispatch(
      `data/${DataModules.LEADS_VAULT_ASSETS}/create`,
      {
        id: leadId,
        data: {
          encrypted: false,
          note: this.form.note,
          pinned: false
        }
      }
    );
  }

  // Computed

  public get canCreateLead() {
    return this.$userCan("create_lead");
  }
}
